import React, { useState, useEffect, useRef, useCallback } from "react"; // Added useCallback
import "./Subscription.css";
import logo1 from "../Catreingfolder/MAAMAAS_LOGO_V1-01[1].png"; // Default logo
import banner from "../Catreingfolder/busibesnetwokbanner.png"; // Default banner
import { Link } from "react-router-dom";
import {
    FaWhatsapp,
    FaInstagram,
    FaFacebookF,
    FaYoutube,
    FaEdit, // Keep if used elsewhere, otherwise can remove
} from "react-icons/fa";

import { FaChevronDown, FaChevronUp, FaCommentAlt, FaPaperPlane } from "react-icons/fa";



const cateringOffers = [
    {
        id: 1,
        gole: "Buffet Lunch",
        description: "Enjoy unlimited buffet with 20% off!",
        couponCode: "BUFFET20",
        startDate: "2025-09-01",
        endDate: "2025-09-30",
        discountPercentage: 20,
        offerType: "buffet",
    },
    {
        id: 2,
        gole: "Wedding Package",
        description: "Flat 15% off on wedding catering bookings.",
        couponCode: "WED15",
        startDate: "2025-09-10",
        endDate: "2025-12-31",
        discountPercentage: 15,
        offerType: "wedding",
    },
    {
        id: 3,
        gole: "Birthday Special",
        description: "Book birthday catering & get 1kg cake free 🎂",
        couponCode: "BIRTHDAYFREE",
        startDate: "2025-09-05",
        endDate: "2025-11-30",
        discountPercentage: 10,
        offerType: "birthday",
    },
    {
        id: 4,
        gole: "Corporate Lunch",
        description: "Get 25% off on corporate lunch packages.",
        couponCode: "CORP25",
        startDate: "2025-09-01",
        endDate: "2025-10-31",
        discountPercentage: 25,
        offerType: "corporate",
    },
];


const CateringAdvertisements = () => {
    const [showMore, setShowMore] = useState(false);
    const [showMoree, setShowMoree] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const scrollContainerRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    // const fileInputRef = useRef(null); // Keep if used elsewhere

    // State for modal visibility
    const [showModal, setShowModal] = useState(false);

    // State for currently displayed data (fetched or default)
    const [currentName, setCurrentName] = useState("MAAMAAS HOUSE"); // Default name
    const [currentYear, setCurrentYear] = useState("1997"); // Default year
    const [currentWhatsapp, setCurrentWhatsapp] = useState("");
    const [currentInstagram, setCurrentInstagram] = useState("");
    const [currentFacebook, setCurrentFacebook] = useState("");
    const [currentTwitter, setCurrentTwitter] = useState("");
    const [currentBanner, setCurrentBanner] = useState(banner); // Default banner image
    const [currentLogo, setCurrentLogo] = useState(logo1); // Default logo image
    const [currentBannerId, setCurrentBannerId] = useState(null); // <<< State for existing Banner ID

    // State for user ID
    const [userId, setUserId] = useState("");

    // State for form inputs within the modal
    const [name, setName] = useState("");
    const [year, setYear] = useState("");
    const [bannerBase64, setBannerBase64] = useState(null); // Use null initially
    const [logoBase64, setLogoBase64] = useState(null); // Use null initially
    const [whatsapp, setWhatsapp] = useState("");
    const [instagram, setInstagram] = useState("");
    const [facebook, setFacebook] = useState("");
    const [twitter, setTwitter] = useState("");
    const [vendorId, setVendorId] = useState(null);
    const isMobile = window.innerWidth <= 768;
    // Optional image states (if needed in payload, currently not used in form)
    // const [whatsappImage, setWhatsappImage] = useState("");
    // const [instagramImage, setInstagramImage] = useState("");
    // const [facebookImage, setFacebookImage] = useState("");
    // const [twitterImage, setTwitterImage] = useState("");

    // Fetch userId from localStorage on component mount
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState("");

    const [ticketType, setTicketType] = useState("");

    const [attachment, setAttachment] = useState(""); // base64 image

    const [isPaused, setIsPaused] = useState(false);
    const [expandedCard, setExpandedCard] = useState(null);
    const scrollRef = useRef(null);

    const toggleCard = (index) => {
        setExpandedCard(expandedCard === index ? null : index);
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const result = reader.result;
                // Ensure we only get base64 data (after the comma)
                const base64Data = result.split(',')[1];
                setAttachment(base64Data);
            };
            reader.readAsDataURL(file);
        }
    };



    const handleSendTicket = async () => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!vendorId || !token) {
            alert("Vendor ID or Token not found in localStorage.");
            return;
        }

        if (!ticketType || !message) {
            alert("Please fill all the fields");
            return;
        }

        const payload = {
            vendorId: Number(vendorId),
            ticketType,
            message,
            attachmentUrl: attachment || "", // base64 encoded image
        };

        try {
            const response = await fetch(
                "https://backend.maamaas.com/food/vendor-tickets/create",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify(payload),
                }
            );

            const result = await response.json();

            if (response.ok) {
                alert("Ticket submitted successfully!");
                setTicketType("");
                setMessage("");
                setAttachment("");
                setIsOpen(false);
            } else {
                console.error("API Error:", result);
                alert(result.message || "Failed to submit ticket.");
            }
        } catch (error) {
            console.error("Fetch Error:", error);
            alert("Something went wrong while submitting the ticket.");
        }
    };


    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        setVendorId(storedVendorId);
    }, []);

    // --- Function to Fetch Banner Data ---
    // Wrapped in useCallback to stabilize its identity if needed as a dependency elsewhere
    const fetchBannerData = useCallback(async () => {
        const currentVendorId = localStorage.getItem("vendorId"); // Fetch fresh vendorId
        const token = localStorage.getItem("authToken"); // ✅ Get token from localStorage

        if (!currentVendorId || !token) {
            console.warn("fetchBannerData: Missing vendorId or authToken.");
            // Reset to defaults if user logs out / no vendor
            setCurrentBanner(banner);
            setCurrentLogo(logo1);
            setCurrentName("MAAMAAS HOUSE");
            setCurrentYear("1997");
            setCurrentWhatsapp("");
            setCurrentInstagram("");
            setCurrentFacebook("");
            setCurrentTwitter("");
            setCurrentBannerId(null);
            setIsLoading(false);
            return;
        }

        setVendorId(currentVendorId); // Update state if necessary
        setIsLoading(true);

        try {
            console.log("Current Vendor ID:", currentVendorId);
            const fetchUrl = `https://backend.maamaas.com/food/banner/vendor/${currentVendorId}`;
            console.log(`Fetching banner data from: ${fetchUrl}`);

            const response = await fetch(fetchUrl, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}` // ✅ Include token
                }
            });

            if (response.status === 404) {
                console.log("No banner data found (404). Using defaults.");
                setCurrentBanner(banner);
                setCurrentLogo(logo1);
                setCurrentName("MAAMAAS HOUSE");
                setCurrentYear("1997");
                setCurrentWhatsapp("");
                setCurrentInstagram("");
                setCurrentFacebook("");
                setCurrentTwitter("");
                setCurrentBannerId(null);
                setIsLoading(false);
                return;
            }

            if (!response.ok) {
                let errorMsg = `Failed to fetch banner data. Status: ${response.status}`;
                try {
                    const errorBody = await response.text();
                    errorMsg += ` Details: ${errorBody}`;
                } catch (e) {
                    // ignore
                }
                throw new Error(errorMsg);
            }

            const data = await response.json();
            console.log("Received banner data:", data);

            setCurrentBanner(
                data.companyBanner ? `data:image/jpeg;base64,${data.companyBanner}` : banner
            );
            setCurrentLogo(
                data.companyLogo ? `data:image/png;base64,${data.companyLogo}` : logo1
            );
            setCurrentName(data.companyName || "MAAMAAS HOUSE");
            setCurrentYear(data.establishedYear || "1997");
            setCurrentWhatsapp(data.whatsappLink || "");
            setCurrentInstagram(data.instagramLink || "");
            setCurrentFacebook(data.facebookLink || "");
            setCurrentTwitter(data.twitterLink || "");
            setCurrentBannerId(data.bannerId || null);
        } catch (error) {
            console.error("Error fetching banner data:", error);
            setCurrentBanner(banner);
            setCurrentLogo(logo1);
            setCurrentName("MAAMAAS HOUSE");
            setCurrentYear("1997");
            setCurrentWhatsapp("");
            setCurrentInstagram("");
            setCurrentFacebook("");
            setCurrentTwitter("");
            setCurrentBannerId(null);
        } finally {
            setIsLoading(false);
        }
    }, []); // No dependencies — vendorId comes from localStorage


    // --- Fetch banner data when component mounts or vendorId changes ---
    useEffect(() => {
        fetchBannerData();
    }, [vendorId, fetchBannerData]);


    // --- Function to handle image selection and conversion to Base64 ---
    const handleImageUpload = (e, type) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64 = reader.result.split(",")[1]; // Get Base64 string only
            switch (type) {
                case "banner": setBannerBase64(base64); break;
                case "logo": setLogoBase64(base64); break;
                // Add other types if needed
                // case "whatsapp": setWhatsappImage(base64); break;
                // case "instagram": setInstagramImage(base64); break;
                // case "facebook": setFacebookImage(base64); break;
                // case "twitter": setTwitterImage(base64); break;
                default: break;
            }
            // Reset the file input value so the same file can be selected again if needed
            e.target.value = null;
        };
        reader.onerror = (error) => {
            console.error("Error reading file:", error);
            alert("Failed to read the selected image file.");
        };
        reader.readAsDataURL(file);
    };


    // --- Function to Open Modal and Pre-fill Form for Editing ---
    const handleOpenModal = () => {
        if (currentBannerId) {
            // --- EDIT MODE: Pre-fill form with current data ---
            console.log("Opening modal in EDIT mode for bannerId:", currentBannerId);
            setName(currentName);
            setYear(currentYear);
            setWhatsapp(currentWhatsapp);
            setInstagram(currentInstagram);
            setFacebook(currentFacebook);
            setTwitter(currentTwitter);
            // **Crucially reset image base64 state - user MUST re-upload for edit**
            // (Based on current validation logic requiring both images)
            setBannerBase64(null);
            setLogoBase64(null);
        } else {
            // --- ADD MODE: Clear form ---
            console.log("Opening modal in ADD mode");
            setName("");
            setYear("");
            setWhatsapp("");
            setInstagram("");
            setFacebook("");
            setTwitter("");
            setBannerBase64(null);
            setLogoBase64(null);
        }
        setShowModal(true); // Open the modal
    };


    // --- Function to Handle Form Submission (Add or Edit) ---
    const handleFormSubmit = async () => {
        const vendorId = localStorage.getItem("vendorId"); // ✅ Use vendorId
        const token = localStorage.getItem("authToken");

        if (!vendorId || !token) {
            alert("User session expired or not found. Please log in again.");
            return;
        }

        if (!name || !year || !bannerBase64 || !logoBase64) {
            alert("Please fill Company Name, Year, and upload BOTH a new Logo and a new Banner image.");
            return;
        }

        const isEditing = !!currentBannerId;
        let url = "";
        let method = "";
        let payload = {};

        if (isEditing) {
            method = "PUT";
            url = `https://backend.maamaas.com/food/banner/edit/${currentBannerId}`;
            payload = {
                bannerId: currentBannerId,
                companyName: name,
                establishedYear: year,
                whatsappLink: whatsapp,
                instagramLink: instagram,
                facebookLink: facebook,
                twitterLink: twitter,
                companyLogo: logoBase64,
                companyBanner: bannerBase64
            };
        } else {
            method = "POST";
            url = `https://backend.maamaas.com/food/banner/add/${vendorId}`;
            payload = {
                companyName: name,
                establishedYear: year,
                whatsappLink: whatsapp,
                instagramLink: instagram,
                facebookLink: facebook,
                twitterLink: twitter,
                companyLogo: logoBase64,
                companyBanner: bannerBase64
            };
        }

        try {
            const response = await fetch(url, {
                method: method,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            console.log("Form submission successful:", result);
            alert("Banner saved successfully.");

        } catch (error) {
            console.error("Error submitting form:", error);
            alert("Failed to submit banner. Please try again.");
        }
    };




    // --- Placeholder data for the right-side scroll section ---
    useEffect(() => {
        const scrollContainer = scrollRef.current;
        let scrollInterval;

        if (scrollContainer && !isPaused) {
            scrollInterval = setInterval(() => {
                if (
                    scrollContainer.scrollTop + scrollContainer.clientHeight >=
                    scrollContainer.scrollHeight
                ) {
                    scrollContainer.scrollTop = 0;
                } else {
                    scrollContainer.scrollTop += 1; // scroll speed
                }
            }, 50);
        }

        return () => clearInterval(scrollInterval);
    }, [isPaused]); // pause state control karega


    const getOfferColor = (type) => {
        switch (type) {
            case "buffet":
                return "#ff6f61";
            case "wedding":
                return "#6a5acd";
            case "birthday":
                return "#ffb347";
            case "corporate":
                return "#2e8b57";
            default:
                return "#333";
        }
    };

    // --- Style for buttons below banner ---
    const buttonStyle = {
        padding: "10px 20px",
        fontSize: "16px",
        borderRadius: "8px",
        border: "none",
        backgroundColor: "green",
        color: "white",
        cursor: "pointer",
        marginTop: "10px",
        fontWeight: "bold"
    };
    const buttonStylee = {
        padding: "10px 20px",
        fontSize: "16px",
        borderRadius: "8px",
        border: "none",
        backgroundColor: "blue",
        color: "white",
        cursor: "pointer",
        marginTop: "10px",
        fontWeight: "bold"
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-2"></div>
                <div
                    style={{ marginTop: isMobile ? '50px' : '0px' }}
                    className="col-lg-7 col-md-7 col-sm-12 col-12 subscription-home"
                >



                </div> {/* End col-lg-7 */}

                {/* Right Sidebar Section */}
                <div className="col-3">
                    <div
                        style={{
                            position: "fixed",
                            bottom: "62px",
                            right: "16px",
                            top: "40px",
                            height: "560px",
                            borderRadius: "8px",
                            padding: "10px",
                            marginTop: "40px",
                        }}
                        className="scroll-fixed-data mobilescroll"
                        onMouseEnter={() => setIsPaused(true)}
                        onMouseLeave={() => setIsPaused(false)}
                    >
                        <div
                            ref={scrollRef}
                            style={{
                                maxHeight: "570px",
                                overflowY: "auto",
                                paddingRight: "5px",
                                scrollbarWidth: "none",
                                msOverflowStyle: "none",
                                marginTop: "40px",
                            }}
                            className="hide-scrollbar"
                        >
                            {cateringOffers
                                .filter((post) => new Date(post.endDate) >= new Date())
                                .map((post, index) => (
                                    <div
                                        key={post.id}
                                        onClick={() => toggleCard(index)}
                                        className="card scroll-data-responsive"
                                        style={{
                                            width: "300px",
                                            marginBottom: "12px",
                                            background: getOfferColor(post.offerType),
                                            borderRadius: "10px",
                                            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                                            cursor: "pointer",
                                            transition: "all 0.3s ease",
                                            padding: "15px",
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                height: "100%",
                                                textAlign: "center",
                                            }}
                                        >
                                            <h4 style={{ color: "#fff", marginBottom: "10px" }}>
                                                {post.gole} Offer 🎉
                                            </h4>
                                            <p style={{ color: "#f5f5f5", fontSize: "15px" }}>
                                                {post.description}
                                            </p>
                                            <button
                                                style={{
                                                    marginTop: "10px",
                                                    backgroundColor: "#f5f5f5",
                                                    color: "#000",
                                                    border: "none",
                                                    padding: "6px 16px",
                                                    borderRadius: "6px",
                                                    cursor: "pointer",
                                                    fontWeight: "bold",
                                                }}
                                            >
                                                Pay
                                            </button>
                                        </div>

                                        {expandedCard === index && (
                                            <div
                                                style={{
                                                    marginTop: "10px",
                                                    backgroundColor: "rgba(255, 255, 255, 0.2)",
                                                    padding: "10px",
                                                    borderRadius: "8px",
                                                    color: "#fff",
                                                }}
                                            >
                                                <p>
                                                    <strong>Coupon Code:</strong> {post.couponCode}
                                                </p>
                                                <p>
                                                    <strong>Valid From:</strong>{" "}
                                                    {new Date(post.startDate).toLocaleDateString()}
                                                </p>
                                                <p>
                                                    <strong>Valid Until:</strong>{" "}
                                                    {new Date(post.endDate).toLocaleDateString()}
                                                </p>
                                                <p>
                                                    <strong>Discount:</strong> {post.discountPercentage}%
                                                </p>
                                            </div>
                                        )}
                                    </div>
                                ))}
                        </div>
                        <div
                            style={{
                                position: "fixed",
                                bottom: "0px",
                                right: "30px",
                                width: "303px",
                                backgroundColor: "#fff",
                                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                                borderRadius: "10px",
                                overflow: "hidden",
                                transition: "height 0.3s ease-in-out",
                                height: isOpen ? "400px" : "50px",
                                zIndex: 9999,
                            }}
                        >

                            <div
                                style={{
                                    backgroundColor: "#b15cd6",
                                    color: "#fff",
                                    padding: "10px",
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    cursor: "pointer",
                                }}
                                onClick={() => setIsOpen(!isOpen)}
                            >
                                <FaCommentAlt style={{ marginLeft: "10px" }} />
                                <span style={{ flexGrow: 1, textAlign: "center" }}>Support</span>
                                {isOpen ? <FaChevronDown style={{ marginRight: "10px" }} /> : <FaChevronUp style={{ marginRight: "10px" }} />}
                            </div>

                            {/* Chat Content */}
                            {isOpen && (
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        flex: 1,
                                        overflowY: "auto",
                                        padding: "10px",
                                        height: "352px",
                                        scrollbarWidth: "none"
                                    }}
                                >
                                    <h4 style={{ textAlign: "center", marginBottom: "10px" }}>Raise a Ticket</h4>

                                    {/* Ticket Type Dropdown */}
                                    <label style={{ fontWeight: "bold" }}>Ticket Type</label>
                                    <select
                                        value={ticketType}
                                        onChange={(e) => setTicketType(e.target.value)}
                                        style={{
                                            marginBottom: "10px",
                                            padding: "8px",
                                            borderRadius: "5px",
                                            border: "1px solid #ccc",
                                            outline: "none",
                                        }}
                                    >
                                        <option value="">Select Ticket Type</option>
                                        <option value="PAYOUT_ISSUE">Payout Issue</option>
                                        <option value="SUBSCRIPTION_ISSUE">Subscription Issue</option>
                                        <option value="ORDER_COMPLAINT">Order Complaint</option>
                                        <option value="TECHNICAL_SUPPORT">Technical Support</option>
                                        <option value="OTHER">Other</option>
                                    </select>

                                    {/* Message Input */}
                                    <label style={{ fontWeight: "bold" }}>Message</label>
                                    <input
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                        placeholder="Type your Issue here..."
                                        rows={3}
                                        style={{
                                            marginBottom: "10px",
                                            padding: "8px",
                                            borderRadius: "5px",
                                            border: "1px solid #ccc",
                                            height: "50px"

                                        }}
                                    />

                                    {/* Attachment Upload */}
                                    <label style={{ fontWeight: "bold" }}>Attachment</label>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={handleImageChange}
                                        style={{ marginBottom: "10px" }}
                                    />

                                    {/* Submit Button */}
                                    <button
                                        onClick={handleSendTicket}
                                        style={{
                                            padding: "10px",
                                            backgroundColor: "#b15cd6",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "5px",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Send Ticket
                                    </button>
                                </div>
                            )}

                        </div>


                    </div>
                </div>
            </div>
        </div>
    );
};

export default CateringAdvertisements;